<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-delivery-notes-emit',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowBuyerDeliveryNoteEmit',
      'isShowNumDeliveryNoteEmit',
      'isShowDateCreationDeliveryNoteEmit',
      'isShowStatusDeliveryNoteEmit',
      'isShowSellerDeliveryNoteEmit',
      'isShowCentroVendedorDeliveryNoteEmit',
      'isShowCentroCompradorDeliveryNoteEmit',
      'isShowCentroEntregaDeliveryNoteEmit',
      'isShowServiceDeliveryNoteEmit',
      'isShowDateIssueDeliveryNoteEmit',
      'isShowDeliveryDateDeliveryNoteEmit',
      'optionsFilterService',
      'canViewDistributionCentres'
    ])
  },

  methods: {
    ...mapActions([
      'isShowBuyerDeliveryNoteEmitAction',
      'isShowNumDeliveryNoteEmitAction',
      'isShowDateCreationDeliveryNoteEmitAction',
      'isShowStatusDeliveryNoteEmitAction',
      'isShowSellerDeliveryNoteEmitAction',
      'isShowCentroVendedorDeliveryNoteEmitAction',
      'isShowCentroCompradorDeliveryNoteEmitAction',
      'isShowCentroEntregaDeliveryNoteEmitAction',
      'isShowDateIssueDeliveryNoteEmitAction',
      'isShowDeliveryDateDeliveryNoteEmitAction',
      'isShowServiceDeliveryNoteEmitAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'comprador':
          isShow = !this.isShowBuyerDeliveryNoteEmit
          this.isShowBuyerDeliveryNoteEmitAction(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowSellerDeliveryNoteEmit
          this.isShowSellerDeliveryNoteEmitAction(isShow)
          break
        case 'num-albaran':
          isShow = !this.isShowNumDeliveryNoteEmit
          this.isShowNumDeliveryNoteEmitAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowStatusDeliveryNoteEmit
          this.isShowStatusDeliveryNoteEmitAction(isShow)
          break
        case 'centro-vendedor':
          isShow = !this.isShowCentroVendedorDeliveryNoteEmit
          this.isShowCentroVendedorDeliveryNoteEmitAction(isShow)
          break
        case 'centro-comprador':
          isShow = !this.isShowCentroCompradorDeliveryNoteEmit
          this.isShowCentroCompradorDeliveryNoteEmitAction(isShow)
          break
        case 'centro-entrega':
          isShow = !this.isShowCentroEntregaDeliveryNoteEmit
          this.isShowCentroEntregaDeliveryNoteEmitAction(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServiceDeliveryNoteEmit
          this.isShowServiceDeliveryNoteEmitAction(isShow)
          break
        case 'fechaissue':
          isShow = !this.isShowDateIssueDeliveryNoteEmit
          this.isShowDateIssueDeliveryNoteEmitAction(isShow)
          break
        case 'fechaentrega':
          isShow = !this.isShowDeliveryDateDeliveryNoteEmit
          this.isShowDeliveryDateDeliveryNoteEmitAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.canViewDistributionCentres) {
        this.columns = [
          {
            text: this.$t('deliverynote.filters.buyer.value'), value: 'comprador', show: this.isShowBuyerDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.seller.value'), value: 'vendedor', show: this.isShowSellerDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.num_deliverynote.value'), value: 'num-albaran', show: this.isShowNumDeliveryNoteEmit
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowDateCreationDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.status.value'), value: 'estado', show: this.isShowStatusDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.seller_centre.value'), value: 'centro-vendedor', show: this.isShowCentroVendedorDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.buyer_centre.value'), value: 'centro-comprador', show: this.isShowCentroCompradorDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.delivery_centre.value'), value: 'centro-entrega', show: this.isShowCentroEntregaDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.delivery_entity_table.delivery_date'), value: 'fechaentrega', show: this.isShowDeliveryDateDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.delivery_entity_table.date_issue'), value: 'fechaissue', show: this.isShowDateIssueDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.services.value'), value: 'servicio', show: this.isShowServiceDeliveryNoteEmit
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('deliverynote.filters.buyer.value'), value: 'comprador', show: this.isShowBuyerDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.seller.value'), value: 'vendedor', show: this.isShowSellerDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.num_deliverynote.value'), value: 'num-albaran', show: this.isShowNumDeliveryNoteEmit
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowDateCreationDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.status.value'), value: 'estado', show: this.isShowStatusDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.seller_centre.value'), value: 'centro-vendedor', show: this.isShowCentroVendedorDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.delivery_entity_table.delivery_date'), value: 'fechaentrega', show: this.isShowDeliveryDateDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.delivery_entity_table.date_issue'), value: 'fechaissue', show: this.isShowDateIssueDeliveryNoteEmit
          }, {
            text: this.$t('deliverynote.filters.services.value'), value: 'servicio', show: this.isShowServiceDeliveryNoteEmit
          }
        ]
      }
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            this.columns.splice(index, 1)
          }
        }
        this.isShowServiceDeliveryNoteEmitAction(false)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
